module.exports = __webpack_public_path__ + "img/BannerRenovacionDebidaDiligencia.2ca92101.png";